__turbopack_context__.v({
  "container": "Progress-module__f1QUTq__container",
  "danger": "Progress-module__f1QUTq__danger",
  "header": "Progress-module__f1QUTq__header",
  "indeterminate": "Progress-module__f1QUTq__indeterminate",
  "indicator": "Progress-module__f1QUTq__indicator",
  "label": "Progress-module__f1QUTq__label",
  "lg": "Progress-module__f1QUTq__lg",
  "md": "Progress-module__f1QUTq__md",
  "primary": "Progress-module__f1QUTq__primary",
  "sm": "Progress-module__f1QUTq__sm",
  "success": "Progress-module__f1QUTq__success",
  "track": "Progress-module__f1QUTq__track",
  "value": "Progress-module__f1QUTq__value",
  "warning": "Progress-module__f1QUTq__warning",
});
